import { USER_TYPES } from '@medflex/utils/constants';
import useSelectedContactType from './useSelectedContactType';

const useIsSelectedContactPhysician = () => {
  const selectedContactType = useSelectedContactType();
  return selectedContactType === USER_TYPES.PHYSICIAN;
};

export default useIsSelectedContactPhysician;
